export default __webpack_public_path__ + "static/media/MinecraftBackground.53642881.jpg";